<template>
	<div style="width: 100%;height: 100%;background-color: #142537;">
		<div class="caption-title">
			<i class="fl"><img src="./static/title-left.png"></i>
			<span class="biaoti fl">{{$tt('运营总览')}}</span>
			<i class="fr"><img src="./static/title-right.png"></i>
		</div>
		<!-- 内容正文 -->
		<div class="zhenwen" style="width: 100%;height: 100%;">
			<!--左侧图表展示 -->
			<leftView :deviceTypeSelectList="deviceTypeSelectList" :batchSelectList="batchSelectList"></leftView>
			<!--中部图表展示 -->
			<centerView></centerView>
			<!--右侧图表展示 -->
			<rightView :deviceTypeSelectList="deviceTypeSelectList" :batchSelectList="batchSelectList"></rightView>
		</div>
	</div>
</template>

<script>
	import Qs from 'qs'
	import leftView from './BigScreenChild/left.vue'
	import centerView from './BigScreenChild/center.vue'
	import rightView from './BigScreenChild/right.vue'
	export default {
		data() {
			return {
				batchSelectList: [],
				deviceTypeSelectList: []
			}
		},
		components: {
			leftView,
			centerView,
			rightView
		},
		computed: {},
		mounted() {
		},
		created() {},
		watch: {},
		methods: {
			//点击设备行 更改日志查询 设备编号
			changeDeviceAndLog: function(a, b) {
				const _this = this;
				_this.formInline.deviceImei = a.deviceImei;
			},
		}
	}
</script>

<style scoped>
	@import './static/public.css';
	@import './static/jianlisw.css';
	@import './static/media.css';
	.bg {
		height: 100%;
		width: 100%;

		background-color: #000c3b;
	}

	.logTitle {
		width: 100%;
		height: 30px;
		line-height: 30px;
		color: #00FF00;
		margin-top: 10px;
		border-top: 2px solid #26C6F0;
		border-bottom: 2px solid #26C6F0;
	}

	.logBox {
		width: 100%;
	}

	.noPass {
		color: red !important;
	}

	.wgrytj {
		height: 65%;
	}

	.atStyle {
		display: inline-block;
		margin-left: 10px;
	}
</style>
